"use client";

import { CSSProperties, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTheme } from "@/components/theme-provider";
import { getThemePreset } from "@/lib/theme-presets";
import { Z } from "@/lib/z";

// Плавающая пилюля режима «прогулки»: превью взведено (?themePreview=… или
// window.name), ходишь по порталу как обычно и мгновенно переключаешь
// «Текущая ⇄ Кандидат» на любом экране. Внутри фреймов /theme-compare не
// показывается — там темой управляет страница сравнения. Рендер через portal
// в body (transform-предок ломает fixed). Цвета фиксированные тёмные, как у
// шапки /vhod-compare: пилюля — инструмент поверх ОБЕИХ тем.
function segStyle(on: boolean): CSSProperties {
  return {
    border: 0,
    cursor: "pointer",
    borderRadius: 999,
    padding: "4px 10px",
    fontSize: 12,
    fontWeight: 600,
    background: on ? "#7c3aed" : "transparent",
    color: on ? "#ffffff" : "#9a9aa2",
    boxShadow: "none",
    backdropFilter: "none",
  };
}

export function ThemePreviewPill() {
  const { previewName, previewActive, setPreviewActive, clearPreview } = useTheme();
  const [ready, setReady] = useState(false);
  const [framed, setFramed] = useState(false);

  useEffect(() => {
    setReady(true);
    setFramed(window.self !== window.top);
  }, []);

  const preset = getThemePreset(previewName);
  if (!ready || framed || !preset) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        bottom: 14,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: Z.COMMAND,
        display: "flex",
        alignItems: "center",
        gap: 8,
        maxWidth: "calc(100vw - 16px)",
        background: "rgba(23, 23, 26, 0.92)",
        border: "1px solid #2a2a2e",
        borderRadius: 999,
        padding: "5px 6px 5px 14px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.45)",
        backdropFilter: "blur(10px)",
        color: "#cfcfd6",
        fontSize: 12,
        fontWeight: 600,
      }}
    >
      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{preset.label}</span>
      <div style={{ display: "inline-flex", gap: 2, background: "#101012", borderRadius: 999, padding: 2 }}>
        <button type="button" onClick={() => setPreviewActive(false)} style={segStyle(!previewActive)}>
          Текущая
        </button>
        <button type="button" onClick={() => setPreviewActive(true)} style={segStyle(previewActive)}>
          Кандидат
        </button>
      </div>
      <button
        type="button"
        onClick={clearPreview}
        data-tooltip="Выйти из предпросмотра"
        style={{
          border: 0,
          background: "transparent",
          color: "#9a9aa2",
          cursor: "pointer",
          fontSize: 12,
          lineHeight: 1,
          padding: "2px 8px 2px 2px",
          boxShadow: "none",
          backdropFilter: "none",
        }}
      >
        ✕
      </button>
    </div>,
    document.body,
  );
}
